import { useState, useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const checkResourceType = async url => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    if (response.ok) {
      const contentType = response.headers.get('Content-Type');
      if(contentType == 'application/pdf'){
        return true;
      } else {
        return false;
      }
      // Ejemplo: 'image/jpeg' o 'application/pdf'
    }
    return 'No disponible';
  } catch (error) {
    return 'Error';
  }
}

const FilePreviewer = ({ file = "" }) => {
  const [isPdf, setIsPdf] = useState(null); // null indica estado inicial (cargando)
  const momento = new Date().getTime();

  useEffect(() => {
    if (file === "") {
      setIsPdf(false); // Si no hay archivo, no es PDF
      return;
    }

    // Ejecutar la verificación asíncrona
    checkResourceType(file).then((result) => {
      setIsPdf(result); // Actualiza el estado con el resultado
    });
  }, [file]); // Ejecuta cuando cambia el prop file

  if (file == "") {
    return (
      <Stack alignItems="center" justifyContent="center" spacing={2}>
        <SearchOffIcon color="disabled" sx={{ fontSize: 40 }} />
        <Typography className="subtitleMain" variant="h6">
          Sin datos por mostrar
        </Typography>
      </Stack>
    );
  }

  return isPdf ? (
    <iframe
      src={file}
      height="580"
      width="100%"
    />
  ) : (
    <img
      key={momento}
      src={`${file}?t=${momento}`}
      width="95%"
      height="auto"
      alt="Detalle del archivo"
    />
  )
}

export default FilePreviewer;
